import React from 'react';
import { NavLink } from 'react-router-dom';

export const AccountNav = () => {
  return (
    <div className="lg:w-1/4 md:w-1/3 w-full">
        <ul class="my_ac_list">
          <li><NavLink className="mb-[1px] hover:bg-cyan-500 hover:text-white bg-gray-100 text-sm uppercase text-gray-600 px-5 block py-3" to="/account">My Orders</NavLink></li>
          <li><NavLink className="mb-[1px] hover:bg-cyan-500 hover:text-white bg-gray-100 text-sm uppercase text-gray-600 px-5 block py-3" to="/editaccount">Account Information</NavLink></li>
          <li><NavLink className="mb-[1px] hover:bg-cyan-500 hover:text-white bg-gray-100 text-sm uppercase text-gray-600 px-5 block py-3" to="/address">Address Book</NavLink></li>
          <li><NavLink className="mb-[1px] hover:bg-cyan-500 hover:text-white bg-gray-100 text-sm uppercase text-gray-600 px-5 block py-3" to="/prescriptions">My Prescriptions</NavLink></li>
        </ul>
      </div>
  )
}